// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

/////////////////////////////////////////
// ENDPOINT GRPC SCHEMA
/////////////////////////////////////////

export const EndpointGrpcSchema = z.object({
  framing: z.string().nullable(),
  service: z.string().nullable(),
  method: z.string().nullable(),
  requestSchema: z.string().nullable(),
  responseSchema: z.string().nullable(),
  decodeStatus: z.string().nullable(),
  protoSchemaId: z.string().nullable(),
})

export type EndpointGrpc = z.infer<typeof EndpointGrpcSchema>

export default EndpointGrpcSchema;
